module.exports = "/_next/static/images/agco-logo-65765327079f730045cf10464c617129.png";